import { render, staticRenderFns } from "./GraficoMapa.vue?vue&type=template&id=6006c94b&scoped=true&"
import script from "./GraficoMapa.vue?vue&type=script&lang=ts&"
export * from "./GraficoMapa.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoMapa.vue?vue&type=style&index=0&id=6006c94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006c94b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6006c94b', component.options)
    } else {
      api.reload('6006c94b', component.options)
    }
    module.hot.accept("./GraficoMapa.vue?vue&type=template&id=6006c94b&scoped=true&", function () {
      api.rerender('6006c94b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboardEsmax/TiposGraficos/GraficoMapa.vue"
export default component.exports